import { CustomFields } from 'src/Library/Types';

export interface CustomFieldValue {
  dbKey: string;
  value: string;
}

/**
 * Only active custom fields should be rendered / collected.
 */
export const filterActiveCustomFields = (
  fields: CustomFields[] | undefined | null,
): CustomFields[] => (fields || []).filter((field) => field && field.isActive);

/**
 * Transform the antd form's nested `customFields` value
 * ({ [dbKey]: value }) into the backend payload shape ([{ dbKey, value }]),
 * dropping fields the user left empty. A value of `'0'` is preserved.
 */
export const buildCustomFieldsPayload = (
  customFieldsValues: Record<string, string | undefined | null> | undefined | null,
): CustomFieldValue[] => {
  if (!customFieldsValues) return [];
  return Object.keys(customFieldsValues)
    .map((dbKey) => ({ dbKey, value: customFieldsValues[dbKey] as string }))
    .filter(
      (item) => item.value !== undefined && item.value !== null && item.value !== '',
    );
};

/**
 * Prefill value for a CT custom field when editing an existing shipment.
 * `editData.customFields` comes from the shipment detail response as
 * an array of { dbKey, value }.
 */
export const getCustomFieldInitialValue = (
  editData: { customFields?: CustomFieldValue[] } | undefined | null,
  dbKey: string,
): string | undefined => {
  if (!editData || !Array.isArray(editData.customFields)) return undefined;
  const match = editData.customFields.find((field) => field.dbKey === dbKey);
  return match ? match.value : undefined;
};
